import { Logger } from '~/utils/logger'
import {singleSlashPath} from '~/utils/jsonUtil'

const APIURL = {
  WEBSITE_INFO: '/media-cms/h5/webSite/info', // 站点信息查询

  UPLOAD_IMG: '/media-system/h5/file/uploadBase64File', //上传图片

  COLLECT_VIDEO: '/media-site/h5/favorite/collection/save',
  CANCEL_COLLECT: '/media-site/h5/favorite/collection/delete/id', // 取消收藏

  USER_QUESTION_FIND: '/media-member/h5/question/find', // 用户反馈列表
  USER_QUESTION: '/media-member/h5/question', // 用户反馈
  USER_REPEAT_QUESTION: '/media-member/h5/question/repeat', // 用户提交多次提交同一反馈问题
  QUSTION_CHECK: '/media-member/h5/question/check', // 用户反馈入口
  USER_REPLY: '/media-member/h5/question/reply', // 用户回复列表
  USER_READ: '/media-member/h5/question/read', // 用户已读回复问题
  USER_READNUM: '/media-member/h5/question/readNum' // 用户已读回复问题
}

// 广告列表
export const getAdListApi = (params = {}) => {
  return httpRequest.post(APIURL.AD_LIST, params, { server: false })
}

export const webSiteInfoApi = async (params = {}, webSiteJsonApi) => {
  let domain = cleanDomain(params.domain)
  const configUrl = `${webSiteJsonApi}/pages/new/${domain}/info.json`
  // console.log('configUrl', configUrl)
  Logger.info('configUrl:', configUrl)
  try {
    return useFetch(singleSlashPath(configUrl), { responseType: 'json' })
  } catch (error) {}
}

// 上传图片
export const uploadImgApi = (params = {}) => {
  return httpRequest.post(APIURL.UPLOAD_IMG, params, { server: false })
}

// 用户反馈列表
export const userQuestionFindApi = (params = {}) => {
  return httpRequest.post(APIURL.USER_QUESTION_FIND, params, { server: false })
}
// 用户反馈列表
export const userQuestionListApi = (params = {}) => {
  return httpRequest.post(APIURL.USER_QUESTION, params, { server: false })
}
// 用户提交反馈
export const userQuestionSubmitApi = (params = {}) => {
  // console.log('params', params)
  return httpRequest.post(APIURL.USER_QUESTION, params, { server: false })
}
// 用户提交多次提交同一反馈问题
export const userQuestionRepeatSubmitApi = (params = {}) => {
  return httpRequest.post(APIURL.USER_REPEAT_QUESTION, params, { server: false })
}
// 用户回复列表
export const userReplyApi = (params = {}) => {
  return httpRequest.post(APIURL.USER_REPLY, params, { server: false })
}
// 用户已读回复问题
export const userHasReadApi = (params = {}) => {
  return httpRequest.post(APIURL.USER_READ, params, { server: false })
}

// 用户反馈未读数量
export const userNotReadNumApi = (params = {}) => {
  return httpRequest.post(APIURL.USER_READNUM, params, { server: false })
}
